export const subtaskKanbanOptions = [
  'Yet To Start',
  'Start',
  'Complete',
  'Hold',
  'Resume',
  'Reject',
  'Resolve',
  'Rework',
];
export const accessOptions = {
  key2: [
    { key: 6, text: 'Assign Picker', value: 'Assign Picker' },
    {
      key: 7,
      text: 'Move to Climatisation',
      value: 'Move to Climatisation',
    },
    {
      key: 8,
      text: 'Ready for Outward Deliver',
      value: 'Ready for Outward Deliver',
    },
    { key: 9, text: 'Delivered', value: 'Delivered' },
    { key: 10, text: 'Returned', value: 'Returned' },
  ],
};
export const digitizationOptions = {
  key3: [
    { key: 1, text: 'Specification', value: 'Specification' },
    { key: 2, text: 'Digitization', value: 'Digitization' },
    { key: 3, text: 'Quality Check', value: 'Quality Check' },
    { key: 4, text: 'Deliverables', value: 'Deliverables' },
  ],
};
export const restorationOptions = {
  key4: [
    {
      key: 1,
      text: 'Basic Specification from CS',
      value: 'Basic Specification from CS',
    },
    { key: 2, text: 'Sample', value: 'Sample' },
    { key: 3, text: 'Sample QC', value: 'Sample QC' },
    { key: 4, text: 'Analysis', value: 'Analysis' },
    { key: 5, text: 'Estimation', value: 'Estimation' },
    { key: 6, text: 'Production', value: 'Production' },
    { key: 7, text: 'Team Allocation', value: 'Team Allocation' },
    { key: 8, text: 'Cutlist upload', value: 'Cutlist upload' },
    {
      key: 9,
      text: 'Specification by Tech team',
      value: 'Specification by Tech team',
    },
    { key: 10, text: 'Allocation', value: 'Allocation' },
    { key: 11, text: 'QC', value: 'QC' },
    { key: 12, text: 'QA', value: 'QA' },
    { key: 13, text: 'Final QA', value: 'Final QA' },
    { key: 14, text: 'Wave form Check', value: 'Wave form Check' },
    { key: 15, text: 'Confidence Check', value: 'Confidence Check' },
    { key: 16, text: 'MD5 Check Sum', value: 'MD5 Check Sum' },
    {
      key: 17,
      text: 'Final Restoration Report',
      value: 'Final Restoration Report',
    },
    { key: 18, text: 'Output Delivery', value: 'Output Delivery' },
    {
      key: 19,
      text: 'Project closure report',
      value: 'Project closure report',
    },
    {
      key: 20,
      text: 'Client rejection Feedback',
      value: 'Client rejection Feedback',
    },
    { key: 21, text: 'Final Approval', value: 'Final Approval' },
    { key: 22, text: 'Purge', value: 'Purge' },
  ],
};
